import {
  get,
  post
} from '../index'
export default {
  // 修改自己的密码
  updatePasswd (querys) {
    return post('/agent/user/updatePasswd', querys)
  },
  // 获取底部菜单配置信息
  getSystemTabbarInfo () {
    return get('/admin/admin/config/getTabbar')
  },
  // 设置底部菜单信息
  settingSystemTabbarInfo (querys) {
    return post('/admin/admin/config/setTabbar', querys)
  },
  // 获取小程序配置信息
  getAppminiConfigInfo () {
    return get('/admin/admin/config/getAppConfig')
  },
  // 设置小程序配置信息
  setAppminiConfigInfo (querys) {
    return post('/admin/admin/config/setAppConfig', querys)
  },
  // 自动同步服务通知
  getServiceNotice () {
    return get('/admin/admin/config/async')
  },
  // 获取上传配置信息
  getUplaodConfigInfo () {
    return get('/admin/admin/config/getOssConfig')
  },
  // 设置上传配置信息
  settingUploadConfinInfo (querys) {
    return post('/admin/admin/config/updateOssConfig', querys)
  },
  // 设置上传配置信息
  getdraftVersion (querys) {
    return get('/agent/user/draftVersion', querys)
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/system.js